<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="CONDICIONES" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver">
            <b-row class="mb-4 flex-column">
              <p class="configurator-label">Condición del anden</p>
              <b-form-group>
                <b-radio-group stacked size="lg" v-model="form.condition" class="ml-4">
                  <b-radio value="cerrado">
                    Andén cerrado (al interior del edificio)
                  </b-radio>
                  <b-radio value="abierto">
                    Andén abierto (fuera del edificio)
                  </b-radio>
                </b-radio-group>
              </b-form-group>
            </b-row>
            <div class="mb-4">
              <b-row class="flex-column">
                <p class="configurator-label">¿Entorno de lavado/corrosivo?</p>
                <b-form-group>
                  <b-radio-group size="lg" v-model="form.is_corrosive" class="ml-4">
                    <b-radio :value="true">
                      Si
                    </b-radio>
                    <b-radio :value="false">
                      No
                    </b-radio>
                  </b-radio-group>
                </b-form-group>
              </b-row>
              <b-row v-if="form.is_corrosive">
                <ValidationProvider :rules="{ required: form.is_corrosive }" name="Notas corrosivo" style="width: 100%" v-slot="{ valid, errors }">
                  <b-form-group label-class="configurator-label" class="w-100">
                    <template #label>
                      <BlankIcon :field="form.corrosive_notes" />
                      <span>Especifique los productos químicos de lavado o sustancias corrosivas:</span>
                    </template>
                    <b-textarea v-model="form.corrosive_notes" rows="3" trim :state="errors[0] ? false : (valid ? true : false)" />
                  </b-form-group>
                </ValidationProvider>
              </b-row>
            </div>
            <b-row class="mb-4">
              <p class="configurator-label mb-0">
                <BlankIcon :field="form.ramp_vehicle_weight === 0 ? null : form.ramp_vehicle_weight" />
                ¿Tipo de vehículo que circulara por la rampa?
              </p>
              <p class="text-muted mb-1 ml-2" style="font-size: 17px;">Seleccionar el vehículo más pesado el cual va a circular por la rampa a colocar</p>
              <div class="vehicle-images-container">
                <img :src="montacargasImg" class="vehicle-img" :class="[11000, 15000].includes(form.ramp_vehicle_weight) && 'active'" />
                <img :src="carretillaManualImg" class="vehicle-img" :class="form.ramp_vehicle_weight === 145 && 'active'" />
                <img :src="carretillaAutomaticaImg" class="vehicle-img" :class="form.ramp_vehicle_weight === 1765 && 'active'" />
              </div>
              <b-form-group class="w-100">
                <b-select v-model="form.ramp_vehicle_weight" :options="rampVehicleWeightOptions" @change="form.ramp_load_weight = 0">
                  <template #first>
                    <b-select-option v-show="form.ramp_vehicle_weight === 0" :value="0">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row class="mb-4">
              <b-form-group label-class="configurator-label" class="w-100">
                <template #label>
                  <BlankIcon :field="form.ramp_load_weight === 0 ? null : form.ramp_load_weight" />
                  <span>¿Cuál es peso de la carga a transportar por el vehículo seleccionado?</span>
                </template>
                <b-select
                  v-model="form.ramp_load_weight"
                  :options="ramLoadWeightsOptions"
                  :disabled="form.ramp_vehicle_weight === 0"
                >
                  <template #first>
                    <b-select-option v-show="form.ramp_load_weight === 0" :value="0">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row class="mb-4">
              <b-form-group label-class="configurator-label" class="w-100">
                <template #label>
                  <BlankIcon :field="form.frequency_use === 0 ? null : form.frequency_use" />
                  ¿Cuál es la frecuencia de uso por día?
                </template>
                <b-select v-model="form.frequency_use" :options="frequencyUseOptions">
                  <template #first>
                    <b-select-option v-show="!form.frequency_use" :value="0">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row class="mb-4">
              <b-form-group label-class="configurator-label" class="w-100">
                <template #label>
                  <BlankIcon :field="form.estado_angular" />
                  Angular existente instalado en borde
                </template>
                <b-select v-model="form.estado_angular">
                  <template #first>
                    <b-select-option v-show="!form.estado_angular" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                  <b-form-select-option value="existe, firme y fuerte">Existe, firme y fuerte</b-form-select-option>
                  <b-form-select-option value="anclar sobre concreto (estándar)">Anclar sobre concreto (estándar)</b-form-select-option>
                  <b-form-select-option value="empotrado en concreto">Empotrado en concreto</b-form-select-option>
                  <b-form-select-option value="no tiene">No tiene</b-form-select-option>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row class="mb-4">
              <b-form-group label-class="configurator-label" class="w-100">
                <template #label>
                  <BlankIcon :field="form.material_angular" />
                  Material del angular o placa instalado en borde
                </template>
                <b-select v-model="form.material_angular">
                  <template #first>
                    <b-select-option v-show="!form.material_angular" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                  <b-form-select-option value="Angular metálico">Angular metálico</b-form-select-option>
                  <b-form-select-option value="Placa metálica ">Placa metálica</b-form-select-option>
                  <b-form-select-option value="Otro">Otro</b-form-select-option>
                </b-select>
              </b-form-group>
            </b-row>
            <div class="mb-4">
              <b-row>
                <b-form-group label-class="configurator-label" class="w-100">
                  <template #label>
                    <BlankIcon :field="form.arriving_vehicle_type" />
                    ¿Tipo de vehículos que arriban al andén?
                  </template>
                  <b-select v-model="form.arriving_vehicle_type" :options="arrivingVehicleOptions">
                    <template #first>
                      <b-select-option v-show="!form.arriving_vehicle_type" :value="null">
                        -- seleccionar --
                      </b-select-option>
                    </template>
                  </b-select>
                </b-form-group>
                <p v-if="formAlarms['arriving_vehicle_type']" class="w-100 mb-0 text-danger text-center fs-14">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  {{ formAlarms['arriving_vehicle_type'] }}
                </p>
              </b-row>
              <b-row v-if="form.arriving_vehicle_type == 'Otros'">
                <ValidationProvider :rules="{ required: true }" name="Notas vehículo" style="width: 100%" v-slot="{ valid, errors }">
                  <b-form-group label-class="configurator-label" class="w-100">
                    <template #label>
                      <BlankIcon :field="form.arriving_vehicle_notes" />
                      <span>Especifique el tipo de vehículo que arriba al andén</span>
                    </template>
                    <b-textarea v-model="form.arriving_vehicle_notes" rows="2" trim :state="errors[0] ? false : (valid ? true : false)" />
                  </b-form-group>
                </ValidationProvider>
              </b-row>
            </div>
            <b-row class="flex-column">
              <p class="configurator-label">
                <BlankIcon :field="form.leveler_type" />
                El nivelador que se colocará es de:
              </p>
              <b-form-group>
                <b-radio-group size="lg" v-model="form.leveler_type" class="ml-4">
                  <b-radio value="fosa">
                    Fosa
                  </b-radio>
                  <b-radio value="parche">
                    Parche
                  </b-radio>
                </b-radio-group>
              </b-form-group>
            </b-row>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import BlankIcon from '../BlankIcon'
import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import MontacargasImage from 'images/andenes/montacargas.webp'
import CarretillaManualImage from 'images/andenes/carretilla_manual.webp'
import CarretillaAutomaticaImage from 'images/andenes/carretilla_automatica.webp'

export default {
  name: 'Conditions',
  components: { ConfiguratorStepTitle, ValidationObserver, ValidationProvider, BlankIcon },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      formAlarms: {},
      form: {
        condition: 'cerrado',
        is_corrosive: false,
        corrosive_notes: '',
        ramp_vehicle_weight: 0,
        ramp_load_weight: 0,
        frequency_use: 0,
        estado_angular: null,
        material_angular: null,
        arriving_vehicle_type: null,
        arriving_vehicle_notes: '',
        leveler_type: '',
      },
      rampVehicleWeightOptions: [
        { text: 'Montacargas (11000 lbs) (4989.51 kg)', value: 11000 },
        { text: 'Montacargas (15000 lbs) (6803.88 kg)', value: 15000 },
        { text: 'Carretilla manual (transpaleta) (145 lbs) (65.77 kg)', value: 145 },
        { text: 'Carretilla automática (transpaleta) (1765 lbs) (800.59 kg)', value: 1765 }
      ],
      rampLoadByWeight: {
        '11000': [
          { text: 'Menos de 450 kg (1000 lbs)', value: 1000 },
          { text: 'Menos de 1360 kg (3000 lbs)', value: 3000 },
          { text: 'Menos de 1815 kg (5000 lbs)', value: 5000 }
        ],
        '15000': [
          { text: 'Menos de 450 kg (1000 lbs)', value: 1000 },
          { text: 'Menos de 1360 kg (3000 lbs)', value: 3000 },
          { text: 'Menos de 1815 kg (5000 lbs)', value: 5000 }
        ],
        '145': [
          { text: 'Menos de 450 kg (1000 lbs)', value: 1000 },
          { text: 'Menos de 1000 kg (2205 lbs)', value: 2205 }
        ],
        '1765': [
          { text: 'Menos de 450 kg (1000 lbs)', value: 1000 },
          { text: 'Menos de 1000 kg (2205 lbs)', value: 2205 },
          { text: 'Menos de 1360 kg (3000 lbs)', value: 3000 }
        ]
      },
      frequencyUseOptions: [
        { text: 'Menos de 5 ciclos', value: 2 },
        { text: 'Más de 5 ciclos', value: 2.5 },
        { text: 'Más de 10 ciclos', value: 3 }
      ],
      arrivingVehicleOptions: [
        { text: 'General / Dry van 20ft', value: 'general / dry van 20ft' },
        { text: 'High Cube 40”', value: 'high hube 40”' },
        { text: 'Refrigerado', value: 'refrigerado' },
        { text: 'Camiones', value: 'camiones' },
        { text: 'Otros (indicar en notas)', value: 'Otros' },
      ],
      montacargasImg: MontacargasImage,
      carretillaManualImg: CarretillaManualImage,
      carretillaAutomaticaImg: CarretillaAutomaticaImage
    }
  },
  mounted () {
    this.setFormData()
  },
  computed: {
    ...mapState({ anden: state => state.configurator.configurable }),
    ...mapGetters(['configuratorStepNumber', 'getStepAlarms']),
    ramLoadWeightsOptions () {
      return this.rampLoadByWeight[this.form.ramp_vehicle_weight]
    }
  },
  methods: {
    setFormData () {
      if (!this.anden) return

      this.form.condition = this.anden.condition
      this.form.is_corrosive = this.anden.is_corrosive
      this.form.corrosive_notes = this.anden.corrosive_notes
      this.form.ramp_vehicle_weight = this.anden.ramp_vehicle_weight || 0
      this.form.ramp_load_weight = this.anden.ramp_load_weight || 0
      this.form.frequency_use = this.anden.frequency_use || 0
      this.form.estado_angular = this.anden.estado_angular
      this.form.material_angular = this.anden.material_angular
      this.form.arriving_vehicle_type = this.anden.arriving_vehicle_type
      this.form.arriving_vehicle_notes = this.anden.arriving_vehicle_notes
      this.form.leveler_type = this.anden.leveler_type

      this.formAlarms = this.getStepAlarms('conditions')
    },
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.anden[key])
    }
  }
}
</script>

<style scoped>
.vehicle-images-container {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
}
.vehicle-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
}
.vehicle-img.active {
  border: 2px solid #38948F;
  border-radius: 3px;
}
</style>
